document.addEventListener('DOMContentLoaded', function () {

  function setupDropdown(selector, sectionId) {
    const tabs = document.querySelectorAll(`${selector} .detail-summary`);
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        const url = `https://${window.location.hostname}/?section_id=${sectionId}`;

        fetch(url)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const tabPane = doc.querySelector('ul.country-list');

            const targetContainer = this.closest(selector)
                                       .querySelector('.country-dropdown-expand');

            if (tabPane && targetContainer) {
              targetContainer.innerHTML = tabPane.outerHTML;
            }
          })
          .catch(error => {
            const targetContainer = this.closest(selector)
                                         .querySelector('.country-dropdown-expand');
            if (targetContainer) {
              targetContainer.innerHTML = '<p>Error loading tab content.</p>';
            }
          });
      });
    });
  }

  setupDropdown('.country-dropdown', 'ajax-localization');
  setupDropdown('.lang-dropdown', 'ajax-localization2');

});
